import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/outline';

export default function SpreadNavigation({
  currentSpread,
  totalPages,
  onPrevious,
  onNext,
  canGoPrevious,
  canGoNext
}) {
  const maxSpreads = Math.ceil(totalPages / 2);
  const displayText = currentSpread === 0 ? 
    'Cover Spread' : 
    `Pages ${(currentSpread - 1) * 2 + 1}-${Math.min(currentSpread * 2, totalPages)}`;

  return (
    <div className="flex items-center justify-between px-4 py-2 bg-white rounded-lg shadow-sm">
      <button
        onClick={onPrevious}
        disabled={!canGoPrevious}
        className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronLeftIcon className="h-5 w-5 text-gray-500" />
      </button>

      <span className="text-sm text-gray-600">
        {displayText} of {totalPages} pages
      </span>

      <button
        onClick={onNext}
        disabled={!canGoNext}
        className="p-1 rounded-full hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <ChevronRightIcon className="h-5 w-5 text-gray-500" />
      </button>
    </div>
  );
}